// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-dialog__message{font-size:20px}.scenery:not(:last-child):after{display:none}", ""]);
// Exports
module.exports = exports;
